import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { ConversationService } from "@ramudden/services";

export const conversationIdInterceptor: HttpInterceptorFn = (request, next) => {
    const conversationService = inject(ConversationService);
    const conversationId = conversationService.conversationId;

    if (!conversationId) {
        return next(request);
    }

    const requestClone = request.clone({
        setHeaders: {
            "X-Conversation-Id": conversationId,
        },
    });

    return next(requestClone);
};
